import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'contexts/AuthContext';

export interface ResumeSubscriptionParams {
  workspaceId: string;
  workspaceSlug: string;
}

export const useResumeSubscription = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<void, Error, ResumeSubscriptionParams>({
    mutationFn: async ({ workspaceId }) => {
      await authApi.post(`/workspace/${workspaceId}/subscription/resume`);
    },
    onSuccess: (_, variables) => {
      // Invalidate subscription queries for this workspace
      queryClient.invalidateQueries({ queryKey: ['subscription', variables.workspaceSlug] });
    },
    onError: (error: Error) => {
      console.error('Error resuming subscription:', error);
    }
  });
};
